import { action, observable } from "mobx";
import NestStore from "~/stores/NestStore";
import CustomerStatisticRepository from "~/repository/Customer/CustomerStatisticRepository";
import CustomerStatistic from "~/models/Customer/CustomerStatistic";

class CustomerStatisticStore extends NestStore {
  /**
   * @property {CustomerStatistic}
   */
  @observable customerStatistic = new CustomerStatistic();

  /**
   * @property {number|null}
   */
  customerId = null;

  customerStatisticRepository = null;

  constructor() {
    super();

    this.customerStatisticRepository = new CustomerStatisticRepository();
  }

  @action
  load(query = null) {
    this.isLoading = true;

    return Promise.all([this.getOne(query)]).finally(() => {
      this.isLoading = false;
    });
  }

  @action
  getOne(query = null) {
    return this.customerStatisticRepository.fetchOne(this.customerId, query).then(response => {
      this.customerStatistic = new CustomerStatistic(response.data.customerStatistic);
    });
  }
}

export default CustomerStatisticStore;
